export const PLAYERS_ROUTER_ROOT = '/players';
export const PLAYERS_ROUTER_NEW = PLAYERS_ROUTER_ROOT + '/new';
export const PLAYERS_ROUTER_EDIT = PLAYERS_ROUTER_ROOT + '/edit/:id';



// WEBPACK FOOTER //
// ./src/components/Players/constants.js